<template>
  <button 
    class="bookmark-btn"
    type="button"
    :class="props.isActive ? 'bookmark-btn--active' : ''"
    :aria-label="props.isActive ? 'Убрать из избранного' : 'Добавить в избранное'"
    :aria-pressed="props.isActive"
  >
    <BookmarkIcon />
  </button>
</template>

<script setup>
  import BookmarkIcon from '@shared/UI/Svg/ui/Bookmark.vue';

  //---------------------------------
  const props = defineProps({
    //Активно ли состояние
    isActive: { type: Boolean, default: false }
  });

  //Production Ready
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>